import React from 'react';
import Assessment from './Assessment';
import Interview from './Interview';
import { useUserStore } from '../../../../store';
import ClientFeedbacks from './ClientFeedbacks';
import classes from './styles.module.scss';

export default function AssessmentAndInterview({
  jobApplication,
  job,
  refetch,
}) {
  const isScreeningAvailable = useUserStore(
    (state) => state.screeningAvailable
  );

  const isClient = useUserStore((state) => state.isClient);

  return (
    <div className={classes.AssessmentAndInterview}>
      {isScreeningAvailable && !isClient && (
        <Assessment candidate={jobApplication} job={job} />
      )}
      {!isClient && (
        <Interview
          jobApplication={jobApplication}
          job={job}
          refetch={refetch}
        />
      )}
      {isClient && (
        <ClientFeedbacks
          jobApplication={jobApplication}
          job={job}
          refetch={refetch}
        />
      )}
    </div>
  );
}
